import './FlashMarkerPreview.css';

// Small looping preview of the map's flashing location marker
export function FlashMarkerPreview() {
    return (
        <div className="fmp-marker" aria-hidden="true">
            <div className="fmp-pulse-ring" />
            <div className="fmp-center-dot" />
        </div>
    );
}
